"use client";
import React, { Suspense, Fragment } from "react";
import PageLayout from "@/layouts/pageLayout";
import HeroComponent from "./components/hero";
import CloudCardsTabs from "./components/services";
import FaqComponent from "./components/faqs";
import IntroComponent from "./components/intro";

const CloudServicesPage = () => {
  return (
    <Fragment>
      <HeroComponent />
      <PageLayout showContactForm showFeatures spacing={20} marginTop={0}>
        <IntroComponent />
        <Suspense>
          <CloudCardsTabs />
        </Suspense>
        <FaqComponent />
      </PageLayout>
    </Fragment>
  );
};

export default CloudServicesPage;
